module.exports = __webpack_public_path__ + "img/background.8eb8eaf1.png";